import { dateValidationByDDMMYY } from '../../app/utils/validation';
import { customMoengageNames } from './constants';

function trackUserEvents(name, value, phoneNumber) {
  // window?.Moengage.identifyUser(userId);
  if (!window?.Moengage) return;

  switch (name) {
    case customMoengageNames.userId: {
      if (value && phoneNumber)
        window.Moengage.identifyUser({
          u_mb: phoneNumber,
          uid: value
        });
      break;
    }

    case customMoengageNames.phoneNumber: {
      if (value) window.Moengage.add_mobile(`${value}`);
      break;
    }

    case customMoengageNames.name: {
      const list = value.split(' ');
      const firstName = list[0];
      const lastName = list.slice(1).join(' ');
      if (firstName) window.Moengage.add_first_name(firstName);
      if (lastName) window.Moengage.add_last_name(lastName);
      break;
    }

    case customMoengageNames.gender: {
      if (value) window.Moengage.add_gender(value);
      break;
    }

    case customMoengageNames.email: {
      if (value) window.Moengage.add_email(value);
      break;
    }

    case customMoengageNames.dateOfBirth: {
      if (dateValidationByDDMMYY(value)) {
        const [day, month, year] = value.split('/').map(Number);
        const date = new Date(year, month - 1, day);
        const birthMonthName = date.toLocaleString('en-US', {
          month: 'long',
          timeZone: 'UTC'
        });

        window.Moengage.add_user_attribute(
          customMoengageNames.dateOfBirth,
          date
        );
        window.Moengage.add_user_attribute(
          customMoengageNames.birthdayMonth,
          birthMonthName
        );
      }
      break;
    }

    case customMoengageNames.isMember: {
      window.Moengage.add_user_attribute(customMoengageNames.isMember, value);
      break;
    }

    case customMoengageNames.latLng: {
      window.Moengage.add_user_attribute(customMoengageNames.latLng, value);
      break;
    }

    case customMoengageNames.city: {
      window.Moengage.add_user_attribute(customMoengageNames.city, value);
      break;
    }

    case customMoengageNames.lastLoginDate:
    case customMoengageNames.registrationDate: {
      if (!value) return;

      const date = new Date(value);

      if (!isNaN(date.getTime()))
        window.Moengage.add_user_attribute(name, date.toISOString());
      break;
    }

    case customMoengageNames.crownPoints: {
      if (!value) return;

      window.Moengage.add_user_attribute(
        name,
        Number.isNaN(value) ? 0 : Number(value)
      );
      break;
    }

    case customMoengageNames.orderMode: {
      if (!value) return;
      window.Moengage.add_user_attribute(name, value);
      break;
    }
    default: {
      break;
    }
  }
}

export default trackUserEvents;
